import { api_get as Get, api_post as JPost } from '@/utils/http.ts'
export default {
  props: {
    // 注册信息
    registerInfo: {
      type: Object,
      default() {
        return {
          // 手机号
          phone: '',
          // 密码
          password: '',
          // 验证码
          verification_code: '',
          // 学段
          ktwelve: '',
          // 学科
          subject: '',
          // 姓名
          realname: '',
          // 学校名字
          school_name: '',
          // 学校对应区域码
          school_region_code: '',
          // 学校id
          school_id: ''
        }
      }
    }
  },
  data() {
    return {
      // 按钮loading
      loading: false,
      // 省集合
      provinces: [],
      // 市集合
      citys: [],
      // 区集合
      areas: [],
      // 学校集合
      schoolList: [],
      // 全部学校集合
      allSchoolList: [],
      // 省
      province: undefined,
      // 市
      area: undefined,
      // 区
      city: undefined,
      // 选择学校下拉菜单
      showSelectSchoolModal: false,
      // 下拉菜单tab切换，-1代表全部
      changeTabIndex: -1,
      // 拼音首字母tab切换
      tabs: ['A B C D', 'E F G H', 'I J K L', 'M N O P', 'Q R S T', 'U V W X', 'Y Z'],
      // 英文首字母数组
      listABCD: [],
      listEFGH: [],
      listIJKL: [],
      listMNOP: [],
      listQRST: [],
      listUVWX: [],
      listYZ: [],
      // 所选学校值
      selectdSchoolValue: '',
      // 所选学校的索引
      selectdSchoolIndex: '',
      // 搜索学校名
      schoolName: ''
    }
  },
  computed: {
    // 完成按钮能否点击
    schoolUsable() {
      return this.province && this.city && this.area && this.selectdSchoolValue
    }
  },
  watch: {
    // 监听区域值，为空隐藏选择学校弹窗
    area(value) {
      if (value) return
      this.showSelectSchoolModal = false
    }
  },
  mounted() {
    // 获取所有省集合
    this.getProvinceList()
  },
  methods: {
    // 获取所有省集合
    async getProvinceList() {
      try {
        let res = await Get('/api/auth/region-info')
        if (!res.success) {
          this.provinces = []
          return
        }
        this.provinces = res.data
      } catch (err) {
        this.provinces = []
      }
    },
    // 获取省或市下面的所有集合
    // code:区域码, list:市或区集合
    async getCityOrAreaList(code, list) {
      try {
        let res = await JPost('/api/auth/region-info', {
          region_code: code
        })
        if (!res.success) {
          this[list] = []
          return
        }
        this[list] = res.data
      } catch (err) {
        this[list] = []
      }
    },
    // 获取区下面的所有学校集合
    async getAreaSchoolList(code) {
      try {
        let res = await JPost('/api/auth/get-school', {
          // 区域编码列表，最少为1个，可传入多个，
          region_codes: String(code),
          // 学校等级，对应学段。小学：1，中学：2，高中：4
          school_level: this.registerInfo.ktwelve || 1,
          // 学校全称、简称关键字，如果为空会返回所有学校
          school_name: this.schoolName
        })
        if (!res.success) {
          this.schoolList = []
          return
        }
        // 按照首字母排序
        this.allSchoolList =
          res.data && res.data.sort((a, b) => (a.letters[0] + '').localeCompare(b.letters[0] + ''))
        // 全部展示所有学校
        if (this.changeTabIndex === -1) this.schoolList = this.allSchoolList
        // 按字母筛选数组
        this.allSchoolList.forEach((item) => {
          if (['A', 'B', 'C', 'D'].includes(item.letters[0])) {
            this.listABCD.push(item)
          } else if (['E', 'F', 'G', 'H'].includes(item.letters[0])) {
            this.listEFGH.push(item)
          } else if (['I', 'J', 'K', 'L'].includes(item.letters[0])) {
            this.listIJKL.push(item)
          } else if (['M', 'N', 'O', 'P'].includes(item.letters[0])) {
            this.listMNOP.push(item)
          } else if (['Q', 'R', 'S', 'T'].includes(item.letters[0])) {
            this.listQRST.push(item)
          } else if (['U', 'V', 'W', 'X'].includes(item.letters[0])) {
            this.listUVWX.push(item)
          } else if (['Y', 'Z'].includes(item.letters[0])) {
            this.listYZ.push(item)
          }
        })
      } catch (err) {
        this.schoolList = []
      }
    },
    // 切换省函数
    handleProvinceChange(value) {
      // 置空
      this.city = undefined
      this.area = undefined
      this.selectdSchoolValue = ''
      // 获取省或市下面的所有集合
      this.getCityOrAreaList(value, 'citys')
      window['sensors'].track('RegisterSchoolPage_buttonClick', {
        buttonName: '省'
      })
    },
    // 切换市函数
    handleCityChange(value) {
      // 置空
      this.area = undefined
      this.selectdSchoolValue = ''
      // 获取省或市下面的所有集合
      this.getCityOrAreaList(value, 'areas')
      window['sensors'].track('RegisterSchoolPage_buttonClick', {
        buttonName: '市'
      })
    },
    // 切换区函数
    handleAreaChange(value) {
      this.selectdSchoolValue = ''
      // 切换到全部
      this.changeTabIndex = -1
      // 置空
      this.listABCD = []
      this.listEFGH = []
      this.listIJKL = []
      this.listMNOP = []
      this.listQRST = []
      this.listUVWX = []
      this.listYZ = []
      // 获取区所在的学校
      this.getAreaSchoolList(value)
      window['sensors'].track('RegisterSchoolPage_buttonClick', {
        buttonName: '区'
      })
    },
    // 按学校名查找
    onSearch() {
      this.getAreaSchoolList(this.area)
      window['sensors'].track('RegisterSchoolPage_buttonClick', {
        buttonName: '搜索'
      })
    },
    // 选择全部学校函数
    changeTabAll() {
      this.changeTabIndex = -1
      // 展示全部学校
      this.schoolList = this.allSchoolList
      window['sensors'].track('RegisterSchoolPage_buttonClick', {
        buttonName: '全部'
      })
    },
    // 选择拼音首字母学校函数
    changeTab(item, index) {
      this.changeTabIndex = index
      // 去掉空格
      const str = item.replace(/\s+/g, '')
      // 更改当前所选数据
      this.schoolList = this[`list${str}`]
    },
    // 选择学校
    selectdSchool(item) {
      this.selectdSchoolValue = item.cname
      // 学校名字
      this.registerInfo.school_name = item.cname
      // 学校对应区域码
      this.registerInfo.school_region_code = item.regionCode
      // 学校id
      this.registerInfo.school_id = item.id
      // 学校索引赋值
      this.selectdSchoolIndex = item.id
      this.showSelectSchoolModal = false
      window['sensors'].track('RegisterSchoolPage_buttonClick', {
        buttonName: '学校'
      })
    },
    // 注册完成
    async registerFinished() {
      window['sensors'].track('RegisterSchoolPage_buttonClick', {
        buttonName: '完成'
      })
      this.loading = true
      try {
        let res = await JPost('/api/auth/register', this.registerInfo)
        // 注册失败
        if (!res.success) {
          this.$message.error(res.error)
          return
        }
        // 注册成功
        this.$success({
          title: '注册成功！',
          okText: '立即体验',
          centered: true,
          class: 'register-modal',
          icon: () => <a-icon type="check-circle" theme="filled" />,
          onOk() {
            window.location.href = '/'
          }
        })
      } catch (err) {
      } finally {
        this.loading = false
      }
    }
  }
}
